/**
 * @generated SignedSource<<2338beac59261d813a87c6e917a397db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeletePaymentMethodDialog_paymentMethod$data = {
  readonly cardBrand: string | null | undefined;
  readonly id: string;
  readonly lastFourDigits: string | null | undefined;
  readonly paymentMethodType: string;
  readonly " $fragmentType": "DeletePaymentMethodDialog_paymentMethod";
};
export type DeletePaymentMethodDialog_paymentMethod$key = {
  readonly " $data"?: DeletePaymentMethodDialog_paymentMethod$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeletePaymentMethodDialog_paymentMethod">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeletePaymentMethodDialog_paymentMethod",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardBrand",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastFourDigits",
      "storageKey": null
    }
  ],
  "type": "PaymentMethod",
  "abstractKey": null
};

(node as any).hash = "a17fae15fd5542f4e5598adf76caa115";

export default node;
